import { Component, Input, OnInit } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { USAEPayAchPage } from '../usaepay-ach/usaepay-ach.page';
import { USAepayCardPage } from '../usaepay-card/usaepay-card.page';
import { TranslateService } from '@ngx-translate/core';
import { DdConsentFormPage } from '../../../../payment-plan/dd-consent-form/dd-consent-form.page';
import { CaseService } from 'src/app/services/case.service';
@Component({
  selector: 'app-usaepay-method',
  templateUrl: './usaepay-method.page.html',
  styleUrls: ['./usaepay-method.page.scss'],
})
export class USAEPayMethodPage implements OnInit {
  @Input() caseData;
  @Input() caseId;
  @Input() amount;
  @Input() totalOutstandingWithSymbol;
  @Input() debtorDetails;
  @Input() responseData;
  @Input() caseDetails;
  paymentMethod = [
    {
      title: this.translate.instant('CARD_PAYMENT.TITLE'),
      type: 'card',
      icon: 'card-outline',
      src: null,
    },
    {
      title: this.translate.instant('ACH_PAYMENT.TITLE'),
      type: 'ach',
      icon: 'card-outline',
      src: 'assets/icon/ach2.svg',
    },
  ];

  constructor(private ionNav: IonNav, private translate: TranslateService, private caseService: CaseService) {}

  ngOnInit() {
    const portalSettings = JSON.parse(localStorage.getItem('portal_settings') || 'null');
    const payment_type: any = portalSettings?.payment_type?.usaepay || {};
    this.paymentMethod = this.paymentMethod.filter(method => {
      if (method.type === 'ach') return !!payment_type.key;
      return true;
    });
    if (payment_type.options?.length) {
      this.paymentMethod = this.paymentMethod.filter(method =>
        payment_type.options.includes(method.type)
      );
    }
    if (payment_type.option_labels && Object.keys(payment_type.option_labels).length) {
      this.paymentMethod = this.paymentMethod.map(method => ({
        ...method,
        title: payment_type.option_labels[method.type] ?? method.title
      }));
    }
  }

  handleMethodClick(type) {
    if (type === 'card') {
      this.ionNav.push(USAepayCardPage, {
        amount: this.amount,
        caseId: this.caseId,
        totalOutstandingWithSymbol: this.totalOutstandingWithSymbol,
        debtorDetails: this.debtorDetails,
        responseData: this.responseData,
        caseDetails: this.caseDetails,
      });
    } else if (type == 'ach') {
      if (this.caseService.isDdConsentFormEnabled()) {
        this.ionNav.push(DdConsentFormPage, {
          caseData: this.caseData || this.caseDetails,
          debtorDetails: this.debtorDetails,
          amount: this.amount,
        });
        return;
      }
      this.ionNav.push(USAEPayAchPage, {
        amount: this.amount,
        caseId: this.caseId,
        totalOutstandingWithSymbol: this.totalOutstandingWithSymbol,
        debtorDetails: this.debtorDetails,
        responseData: this.responseData,
        caseDetails: this.caseDetails,
      });
    }
  }
}
